import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const instatus = defineConnector({
  identifier: "instatus",
  name: "Instatus",
  tagLine: "Status pages and incident updates",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.instatus\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [**User settings > Developer settings**](https://dashboard.instatus.com/developer) in your Instatus dashboard and copy your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.instatus.com/v2/pages",
  },
});
